<section class="fullScreenWrapper">
    <img loading="lazy" src="assets/img/icons/alert.svg" class="alertImage" />
    <span class="alertText">[<b>404</b>]</span>
    <span class="alertDescriptionText">Page not found error!</span>
    <div [routerLink]="routerUrl" class="primaryButtonGray" style="margin-top: 4rem">
        Go to {{errorPage}}
    </div>
</section>